// extracted by mini-css-extract-plugin
export default {"name":"brandsTable_name__bdFKa","avatar":"brandsTable_avatar__+o+3S","link":"brandsTable_link__TXp3h","editBtn":"brandsTable_editBtn__5ZMJ1"};